module.exports = __webpack_public_path__ + "static/4-6a052fbed0683a67a5417e588d6f0502.jpg";